/**
 * Um componente reutilizável para exibir ícones nos diferentes estados da aplicação.
 * Permite renderizar tanto ícones do FontAwesome quanto imagens, dependendo das props fornecidas.
 * 
 * @param {Object} props - As propriedades do componente
 * @param {Object} props.icon - O ícone do FontAwesome a ser exibido (opcional)
 * @param {string} props.imageSrc - O caminho para a imagem a ser exibida (opcional)
 * @param {string} props.altText - O texto alternativo para a imagem (para acessibilidade)
 * @param {string} props.iconContainerClass - A classe CSS para o contêiner do ícone
 * @param {string} props.iconClass - A classe CSS para o ícone ou imagem
 * 
 * @returns {JSX.Element} Um contêiner div com o ícone ou imagem dentro
 */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classes from '../../RescueCode.module.scss';

const StateIcon = ({ icon, imageSrc, altText, iconContainerClass, iconClass }) => {
  // Renderiza uma imagem se imageSrc for fornecido, caso contrário usa o ícone do FontAwesome
  return (
    <div className={classes.iconContainerClass}>
      {imageSrc ? (
        // Caso tenha uma imagem: renderiza o elemento img
        <img src={imageSrc} alt={altText || ""} className={iconClass} />
      ) : (
        // Caso não tenha imagem: renderiza um ícone do FontAwesome
        <div className={iconClass}>
          <FontAwesomeIcon icon={icon} />
        </div>
      )}
    </div>
  );
};

export default StateIcon;